import gql from 'graphql-tag';

const AUTH_ORGANIZATION = gql`
  query getOrganization {
    getOrganizationResponse
      @rest(
        type: "GetOrganization"
        path: "/auth/organization/"
        method: "GET"
      ) {
      id
      name
      fqdn
      serverIP: server_ip
      os
      offline
      serverVersion: server_version
    }
  }
`;

export default {
  AUTH_ORGANIZATION,
};